//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import QfColorPicker from "../qf-color-picker";

export default {
    name: "QfPTextFont",
    components: { QfColorPicker },
    data() {
        return {
            localProperties: null,
            fontColor: null,
            fontSize: null,
            fontFamily: null,
            fontOptions: [
                { label: "default", value: null },
                { label: "Open-Sans", value: "Open-Sans" },
                { label: "Roboto", value: "Roboto" },
                { label: "Roboto Slab", value: "Roboto Slab" },
                { label: "Montserrat", value: "Montserrat" },
                { label: "Libre Baskerville", value: "Libre Baskerville" },
                { label: "Source Sans Pro", value: "Source Sans Pro" },
                { label: "Lato", value: "Lato" },
                { label: "Merriweather", value: "Merriweather" },
                { label: "Space Mono", value: "Space Mono" },
                { label: "Yeseva One", value: "Yeseva One" }
            ]
        };
    },
    watch: {
        activeComponent: {
            handler(val) {
                this.localProperties = this.properties[val];
                this.fontColor = this.localProperties.fontColor || null;
                this.fontSize = this.localProperties.fontSize || null;
                this.fontFamily = this.localProperties.fontFamily || null;
            },
            immediate: true
        },
        fontColor(val) {
            this.localProperties.fontColor = val;
        }
    },
    computed: {
        ...mapState("components", ["properties", "activeComponent"])
    },
    methods: {

    }
};
